import { FeaturesHighlight } from '@/libraries/design/patterns/features-highlight/src/features-highlight';
import { RichTextComponent } from '@/libraries/design/utils';

export interface UniformFeaturesHighlightProps {
	title?: string;
	description?: string;
	richText?: string;
	linkText?: string;
	linkHref?: string;
	feature1Eyebrow?: string;
	feature1Title: string;
	feature1Body?: string;
	feature1RichText?: string;
	feature1ImageSrc: string;
	feature1ImageAltText?: string;
	feature1VideoSrc?: string;
	feature1VideoAltText?: string;
	feature1VideoPoster?: string;
	feature2Eyebrow?: string;
	feature2Title: string;
	feature2Body?: string;
	feature2RichText?: string;
	feature2ImageSrc: string;
	feature2ImageAltText?: string;
	feature2VideoSrc?: string;
	feature2VideoAltText?: string;
	feature2VideoPoster?: string;
	feature3Eyebrow?: string;
	feature3Title?: string;
	feature3Body?: string;
	feature3RichText?: string;
	feature3ImageSrc: string;
	feature3ImageAltText?: string;
	feature3VideoSrc?: string;
	feature3VideoAltText?: string;
	feature3VideoPoster?: string;
}

const UniformFeaturesHighlight = (props: UniformFeaturesHighlightProps) => {
	return (
		<FeaturesHighlight
			title={props.title}
			description={props.richText ? <RichTextComponent text={props.richText} /> : props.description}
			linkText={props.linkText}
			linkHref={props.linkHref}
			feature1Eyebrow={props.feature1Eyebrow}
			feature1Title={props.feature1Title}
			feature1Body={
				props.feature1RichText ? (
					<RichTextComponent text={props.feature1RichText} />
				) : (
					props.feature1Body
				)
			}
			feature1ImageSrc={props.feature1ImageSrc}
			feature1ImageAltText={props.feature1ImageAltText}
			feature1VideoSrc={props.feature1VideoSrc}
			feature1VideoAltText={props.feature1VideoAltText}
			feature1VideoPoster={props.feature1VideoPoster}
			feature2Eyebrow={props.feature2Eyebrow}
			feature2Title={props.feature2Title}
			feature2Body={
				props.feature2RichText ? (
					<RichTextComponent text={props.feature2RichText} />
				) : (
					props.feature2Body
				)
			}
			feature2ImageSrc={props.feature2ImageSrc}
			feature2ImageAltText={props.feature2ImageAltText}
			feature2VideoSrc={props.feature2VideoSrc}
			feature2VideoAltText={props.feature2VideoAltText}
			feature2VideoPoster={props.feature2VideoPoster}
			feature3Eyebrow={props.feature3Eyebrow}
			feature3Title={props.feature3Title}
			feature3Body={
				props.feature3RichText ? (
					<RichTextComponent text={props.feature3RichText} />
				) : (
					props.feature3Body
				)
			}
			feature3ImageSrc={props.feature3ImageSrc}
			feature3ImageAltText={props.feature3ImageAltText}
			feature3VideoSrc={props.feature3VideoSrc}
			feature3VideoAltText={props.feature3VideoAltText}
			feature3VideoPoster={props.feature3VideoPoster}
		/>
	);
};

export default UniformFeaturesHighlight;
